// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonWithProgress_wrapper__lGT7i","buttonProgress":"ButtonWithProgress_buttonProgress__cYZpF"};